import React, { useCallback, useMemo } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { DownloadPDFIcon } from 'dashboard409a/common/icons/downloadPDFIcon';
import { RootStateType } from 'dashboard409a/states/store';
import { useDocuments } from 'services/hooks';
import theme from 'theme';
import { useAccordionReportHeaderStyles } from './styles';
import { AccordionReportHeaderProps } from './types';

const AccordionReportHeader: React.FC<AccordionReportHeaderProps> = ({ reportName }) => {
  const classes = useAccordionReportHeaderStyles(theme);
  const { currentMeasurementDate, currentValuationScalarOpinion } = useSelector((state: RootStateType) => ({
    currentMeasurementDate: state.global.currentMeasurementDate,
    currentValuationScalarOpinion: state.valuation.currentValuationScalarOpinion,
  }));
  const { downloadValuationReport } = useDocuments(currentMeasurementDate);

  const handleClick = useCallback(async () => {
    if (currentValuationScalarOpinion?.valuation_report) {
      await downloadValuationReport(currentValuationScalarOpinion.valuation_report);
    }
  }, [currentValuationScalarOpinion, downloadValuationReport]);

  const downloadIcon = useMemo(() => <DownloadPDFIcon />, []);

  return (
    <Box mt={4} display="flex" justifyContent="space-between" alignItems="center" width="100%">
      <div>
        <Typography variant="h6" component="h6" gutterBottom>
          {reportName} Report
        </Typography>
        <Typography variant="body2" component="p">
          Overview of the documentation analyzed
        </Typography>
      </div>
      {
        currentValuationScalarOpinion?.valuation_report
        && <Button
          variant="outlined"
          color="primary"
          startIcon={downloadIcon}
          onClick={handleClick}
          className={classes.button}>
          {reportName} Final Report PDF
        </Button>
      }
    </Box>
  );
};

export default AccordionReportHeader;
